import {
	CHANGE_DATE_START,
	CHANGE_DATE_END,
	CLEAR_FILTER_ALL
} from '../actions';
// import moment from 'moment'
// import { getYearMontDate } from "../../helpers/Utils";

// let today = moment();
let today = ''
// let filterDayAgo = moment().subtract(30,'d')
// let filterDayAgo = moment().subtract(365,'d')
// let filterDayAgo = ''
const INIT_STATE = {
	// dateStart: filterDayAgo,
	// dateEnd: today
	dateStart: null,
	dateEnd: null
};

export default (state = INIT_STATE, action) => {
	// console.log('date ->', action)
	switch (action.type) {
		case CHANGE_DATE_START:
			return { ...INIT_STATE, ...state, dateStart: action.payload };
		case CHANGE_DATE_END:
			return { ...INIT_STATE, ...state, dateEnd: action.payload };
		case CLEAR_FILTER_ALL:
			return { ...state, dateStart: '', dateEnd: today };
		default: return { ...state };
	}
}
